export default __webpack_public_path__ + "static/media/playlist-icon-white.0b1cac4a.svg";